var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0c.552 0 1 .451 1 .99V2c2.21 0 4 1.79 4 4v11c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4V.99c0-.507.383-.926.883-.983L5 0c.552 0 1 .451 1 .99V2h8V.99c0-.507.383-.926.883-.983L15 0zm3 11H2v6c0 1.105.895 2 2 2h12c1.105 0 2-.895 2-2v-6zm-2-7v1.01c0 .507-.383.926-.883.983L15 6c-.552 0-1-.451-1-.99V4H6v1.01c0 .507-.383.926-.883.983L5 6c-.552 0-1-.451-1-.99V4c-1.105 0-2 .895-2 2v3h16V6c0-1.105-.895-2-2-2z",
    transform: "translate(4.000000, 3.000000)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e22316c0942a9cda08dec47dbb8d6cf9.svg";
export { ForwardRef as ReactComponent };